import { useEffect, useState } from "react";
import { isVisible, mustGetElementById, mustQuerySelectorAtIndex } from "./helpers";
import { useProxyError } from "./useProxyError";
import { useProxyAction } from "./useProxyAction";

const getVerificationCodeInput = () => mustGetElementById<HTMLInputElement>('verificationCode');

const getCodeVerification = () => mustGetElementById<HTMLButtonElement>('codeVerification');
const getSendCodeButton = () => mustGetElementById<HTMLButtonElement>('sendCode');
const getCallMeButton = () => mustGetElementById<HTMLButtonElement>('verifyPhone');
const getVerifyCodeButton = () => mustGetElementById<HTMLButtonElement>('verifyCode');
const getContinueButton = () => mustGetElementById<HTMLButtonElement>('continuePhone');
const getCancelButton = () => mustGetElementById<HTMLButtonElement>('cancel');
const getSendANewCodeAnchor = () => mustGetElementById<HTMLAnchorElement>('retryCode');

const getPageError = () => mustGetElementById('errorMessage');
const getVerificationCodeError = () => mustQuerySelectorAtIndex('.error.itemLevel', 0, 'verification code error');

export function usePhoneFactorProxy({ verificationCode } : {
  verificationCode: string
}) {
  // fields
  useEffect(() => {
    const verificationCodeInput = getVerificationCodeInput();
    verificationCodeInput.value = verificationCode;
    if (verificationCode.length === 0) return;
    verificationCodeInput.dispatchEvent(new Event('input'));
  }, [verificationCode]);

  // actions
  const sendCodeAction = useProxyAction(getSendCodeButton);
  const callMeAction = useProxyAction(getCallMeButton);
  const verifyCodeAction = useProxyAction(getVerifyCodeButton);
  const continueAction = useProxyAction(getContinueButton);
  const cancelAction = useProxyAction(getCancelButton);
  const sendANewCodeAction = useProxyAction(getSendANewCodeAnchor);

  // errors
  const pageError = useProxyError(getPageError);
  const verificationCodeError = useProxyError(getVerificationCodeError);

  if(verificationCodeError !== undefined && verificationCodeError !==""){
    sendANewCodeAction.visible = true;
  }

  const [showCodeVerification, setShowCodeVerification] = useState(false);
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const element = mutation.target as HTMLElement;
        setShowCodeVerification(isVisible(element));
      }
    });

    const element = getCodeVerification();
    observer.observe(element, { attributes: true, attributeFilter: ['aria-hidden'] });
    setShowCodeVerification(isVisible(element));

    return () => observer.disconnect();
  }, []);

  const [phoneNumber, setPhoneNumber] = useState('');
  useEffect(() => {
    const phoneElement = document.querySelector('.phoneNumber .number');
    const phoneNumber = phoneElement?.textContent ?? '';
    setPhoneNumber(phoneNumber);
  }, []);

  return {
    sendCodeAction, callMeAction, verifyCodeAction, continueAction, cancelAction, sendANewCodeAction,
    showCodeVerification, pageError, verificationCodeError, phoneNumber
  };
}
